export interface RuntimeConfig {
  apiUrl: string;
  userPoolId: string;
  userPoolClientId: string;
  cognitoDomain: string;
  region: string;
}

let _config: RuntimeConfig | null = null;

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  if (_config) return _config;
  const res = await fetch("/config.json", { cache: "no-store" });
  if (!res.ok) throw new Error("failed to load /config.json");
  _config = (await res.json()) as RuntimeConfig;
  return _config;
}

export function getConfig(): RuntimeConfig {
  if (!_config) throw new Error("runtime config not loaded");
  return _config;
}
